/* esm.sh - applesauce-core@5.2.0/dist/observable/watch-event-updates */
export * from "/*applesauce-core@5.2.0/esnext/dist/observable/watch-event-updates.mjs";
